var _mask, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeDefaultBanner(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "home-default-banner_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 780
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#214460",
    d: "M0 0h1440v780H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#home-default-banner_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1463.51-60l-232.5 157.32-127.49 458.251L1463.51-60zM877.935 108.778l150.085-23.414 58.67 95.85-68.27 121.403-53.792-95.521L750.5 567.029l127.435-458.251zM750.498 567.027L518 724.347l359.933-615.57-127.435 458.25zm353.022-11.46l-150.025 23.415-58.728-95.851 68.324-121.403 53.739 95.521 214.18-359.933-127.49 458.251z",
    fill: "url(#home-default-banner_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#home-default-banner_svg__filter0_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1335.76,
    cy: 84.165,
    r: 337.792,
    fill: "#1A1538"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#home-default-banner_svg__filter1_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 388.814,
    cy: 922.569,
    r: 337.792,
    fill: "#1A1538"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#home-default-banner_svg__filter2_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1439.86,
    cy: 858.17,
    r: 355.208,
    fill: "url(#home-default-banner_svg__paint1_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "home-default-banner_svg__filter0_f",
    x: 633.973,
    y: -617.626,
    width: 1403.58,
    height: 1403.58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 182,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-default-banner_svg__filter1_f",
    x: -312.978,
    y: 220.778,
    width: 1403.58,
    height: 1403.58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 182,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-default-banner_svg__filter2_f",
    x: 784.648,
    y: 202.962,
    width: 1310.42,
    height: 1310.42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-default-banner_svg__paint0_linear",
    x1: 309.924,
    y1: 942.221,
    x2: 1418.29,
    y2: 801.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-default-banner_svg__paint1_linear",
    x1: 1215.88,
    y1: 779.893,
    x2: 1617.13,
    y2: 1363.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D3FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9878FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDefaultBanner);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };